import * as React from 'react';

import { RouteStore } from 'bernie-core';

import { UitkRemovablePill } from 'uitk-react-pill';

import { amenityLegacyEquals } from 'utils/amenity-mapper';

import { stringify } from 'query-string';

export interface PlaybackFilterPillProps {
  pill: PillProps;
  routeStore?: RouteStore;
  analytics?: any;
  defaults?: any;
  disabled: boolean;
}

export interface PillProps {
  query?: string;
  name: string;
  label: string;
  value: any;
  generated: boolean; // Only set by BEX API
}

export interface PlaybackFilterPillState {
  hide: boolean;
}

export const PlaybackFilterPill: React.FunctionComponent<PlaybackFilterPillProps> = props => {
  const [hide, setHide] = React.useState(false);
  const { analytics, defaults, disabled, pill, routeStore } = props;

  if (hide || !pill || !pill.label) {
    return null;
  }

  const { name, label, value } = pill;

  const sendTracking = () => {
    const suffix = `playback.${name}.${value}`;

    analytics.clickTracker(`.${suffix}`, suffix)();
  };

  const dismissPillAndUpdateSearch = () => {
    sendTracking();
    updateSearchForDismiss();
    setHide(true);
    logAdRefresh('remove');
  };

  const updateSearchForDismiss = () => {
    if (pill.query && pill.query.length > 0) {
      routeStore.updateSearch(pill.query);
    } else if (pill.generated) {
      // BEX API does not return pills urls. Instead we can calculate which param to remove from
      // the information we already have
      const currentParams = { ...routeStore.queryParams };
      const dismissValue = pill.value;
      const isPriceFilter = pill.name === 'price';
      const isMultiplePriceFiltersSelected = dismissValue && dismissValue.toString().indexOf(',') >= 0;
      if (isPriceFilter && isMultiplePriceFiltersSelected) {
        currentParams[pill.name] = '';
        routeStore.updateSearch(stringify(currentParams));
      } else if (defaults && defaults[pill.name]) {
        currentParams[pill.name] = defaults[pill.name];
        routeStore.updateSearch(stringify(currentParams));
      } else {
        const preFilteredParams = currentParams[pill.name];
        let filteredParams;
        if (preFilteredParams instanceof Array) {
          filteredParams = preFilteredParams.filter(pillValue => !amenityLegacyEquals(pillValue, dismissValue));
        } else {
          filteredParams = amenityLegacyEquals(preFilteredParams, dismissValue) ? '' : preFilteredParams;
        }
        currentParams[pill.name] = filteredParams;
        routeStore.updateSearch(stringify(currentParams));
      }
    }
  };

  const logAdRefresh = type => {
    if (document && document.dispatchEvent && typeof document.dispatchEvent === 'function' && CustomEvent) {
      document.dispatchEvent(new CustomEvent('mesoSlotFilterUpdate', { detail: { type: 'slotFilter', editType: type, filterData: pill } }));
    }
  };

  const valueId = typeof value === 'string' ? value.replace(/,/g, '-') : value;
  const key = `playback-filter-pill-${name}-${valueId}`;

  return (
    <UitkRemovablePill id={key} key={key} onClick={dismissPillAndUpdateSearch} disabled={disabled}>
      <span className="playback-pill-grid-item-label">{label}</span>
    </UitkRemovablePill>
  );
};
PlaybackFilterPill.displayName = 'PlaybackFilterPill';
